module.exports = __webpack_public_path__ + "static/media/landing-kitty06.f86547bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/landing-kitty06.svg
// module id = 121
// module chunks = 0